var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-inner" }, [
    _c(
      "div",
      { staticStyle: { width: "fit-content" } },
      [
        _c(
          "div",
          { staticClass: "section" },
          [
            _c(
              "el-form",
              {
                attrs: {
                  disabled: _vm.readonly,
                  inline: true,
                  "label-position": "left",
                  "label-width": "75px"
                }
              },
              [
                _c(
                  "el-checkbox",
                  {
                    model: {
                      value: _vm.job.warehousing,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "warehousing", $$v)
                      },
                      expression: "job.warehousing"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.Storage")))]
                ),
                _c(
                  "el-checkbox",
                  {
                    staticStyle: { "margin-left": "-20px" },
                    model: {
                      value: _vm.job.international,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "international", $$v)
                      },
                      expression: "job.international"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.InternationalTransport")))]
                ),
                _c(
                  "el-checkbox",
                  {
                    staticStyle: { "margin-left": "-20px" },
                    model: {
                      value: _vm.job.landTransportation,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "landTransportation", $$v)
                      },
                      expression: "job.landTransportation"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.DeliveryToDoor")))]
                ),
                _c(
                  "el-checkbox",
                  {
                    staticStyle: { "margin-left": "-20px" },
                    on: {
                      change: function($event) {
                        _vm.job.customsBroker = _vm.job.customs
                          ? _vm.job.customsBroker
                          : 0
                        _vm.job.customsDeclarationType = _vm.job.customs
                          ? _vm.job.customsDeclarationType
                          : -1
                      }
                    },
                    model: {
                      value: _vm.job.customs,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "customs", $$v)
                      },
                      expression: "job.customs"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.CustomsDeclaration")))]
                ),
                _c(
                  "el-checkbox",
                  {
                    staticStyle: { "margin-left": "-20px" },
                    attrs: { no: "isInsure" },
                    model: {
                      value: _vm.job.insure,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "insure", $$v)
                      },
                      expression: "job.insure"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.InsureInfo")) + " ")]
                ),
                _c(
                  "el-checkbox",
                  {
                    staticStyle: { "margin-left": "-20px" },
                    model: {
                      value: _vm.job.itmService,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "itmService", $$v)
                      },
                      expression: "job.itmService"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.ForeignTrade")))]
                ),
                _c(
                  "el-checkbox",
                  {
                    staticStyle: { "margin-left": "-20px" },
                    model: {
                      value: _vm.job.usCustomsClearance,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "usCustomsClearance", $$v)
                      },
                      expression: "job.usCustomsClearance"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("queryJob.UsCustomsClearance")))]
                ),
                !_vm.previewConfig
                  ? _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: ["button_insurance_toInsure"],
                            expression: "['button_insurance_toInsure']"
                          }
                        ],
                        class: !_vm.isEdit
                          ? "el-button el-button--primary el-button--mini"
                          : "el-button el-button--primary el-button--mini is-disabled",
                        staticStyle: {
                          "min-width": "50px!important",
                          "margin-left": "15px"
                        },
                        attrs: { type: "primary" },
                        on: {
                          click: function() {
                            if (!_vm.isEdit) {
                              _vm.toInsure()
                            }
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.Insure")) + " ")]
                    )
                  : _vm._e(),
                !!_vm.templateName
                  ? _c(
                      "span",
                      {
                        staticClass: "blue",
                        staticStyle: {
                          float: "right",
                          "margin-right": "30px",
                          "line-height": "28px",
                          padding: "0 5px",
                          "white-space": "nowrap"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("CargoMsg.Cargo_SopTemplate")) +
                            ": " +
                            _vm._s(_vm.templateName)
                        )
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          ],
          1
        ),
        _c(
          "tab-booking-FCLUICustom-layout",
          { attrs: { "element-blocks": _vm.elementBlocks } },
          [
            _vm.elementDict.jobNo.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "jobNo" }, slot: "jobNo" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.jobNo.isRequire ? "blue" : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.jobNo.label
                      },
                      slot: "label"
                    }),
                    _c("el-input", {
                      attrs: { disabled: true },
                      model: {
                        value: _vm.job.jobNo,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "jobNo", $$v)
                        },
                        expression: "job.jobNo"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.masterJobNo.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "masterJobNo" }, slot: "masterJobNo" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.masterJobNo.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.masterJobNo.label
                      },
                      slot: "label"
                    }),
                    _c("el-input", {
                      attrs: {
                        value: _vm.job.master ? _vm.job.master.jobNo : "",
                        disabled: true
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.customerRefNo.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "customerRefNo" }, slot: "customerRefNo" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.customerRefNo.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.customerRefNo.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-input", {
                      attrs: {
                        disabled: _vm.readonly,
                        "auto-uppercase": true,
                        trim: true
                      },
                      model: {
                        value: _vm.job.customerRefNo,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "customerRefNo", $$v)
                        },
                        expression: "job.customerRefNo"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.customerId.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "customerId" }, slot: "customerId" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.customerId.isRequire ? "blue" : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.customerId.label
                      },
                      slot: "label"
                    }),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center"
                        }
                      },
                      [
                        _c(
                          "el-tooltip",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.sopImageA,
                                expression: "sopImageA"
                              }
                            ],
                            attrs: {
                              no: "sopImageA",
                              content: _vm.$t("SeaExport.SOPReceiver"),
                              placement: "right-end"
                            }
                          },
                          [
                            _c("div", { staticStyle: { height: "28px" } }, [
                              _c("img", {
                                class:
                                  _vm.job.customerId && _vm.readonly
                                    ? ""
                                    : "not-click",
                                staticStyle: {
                                  padding: "5px 0",
                                  cursor: "pointer"
                                },
                                attrs: { src: _vm.sopPic, width: "18" },
                                on: {
                                  click: function($event) {
                                    return _vm.showSopReceiverDialog(
                                      "customer",
                                      _vm.job.customerId
                                    )
                                  }
                                }
                              })
                            ])
                          ]
                        ),
                        _c(
                          "el-tooltip",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.creditTip.showWarningImageA,
                                expression: "creditTip.showWarningImageA"
                              }
                            ],
                            attrs: {
                              content: _vm.creditTip.warningImageATip,
                              placement: "right-end"
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-warning red",
                              staticStyle: { cursor: "pointer" }
                            })
                          ]
                        ),
                        _c("cargo-sales-company-select", {
                          staticStyle: {
                            display: "inline-block",
                            width: "100%"
                          },
                          attrs: {
                            no: "customerId",
                            disabled: _vm.customerEnabled,
                            "method-params": {
                              customer: true,
                              active: true,
                              companyLob: "airImport"
                            },
                            "check-credit": true,
                            "default-value": _vm.job.customerId || "",
                            placeholder: _vm.$t("SeaExport.RequiredItem"),
                            job: _vm.job
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.txtCustomerId_changeHandler(p)
                              _vm.clearPoNo()
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm.isZY
              ? [
                  _c(
                    "el-form-item",
                    {
                      attrs: { slot: "saleProductCode" },
                      slot: "saleProductCode"
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.AllowSaleProduct")))]
                      ),
                      _c("cargo-advance-select", {
                        attrs: {
                          disabled: _vm.readonly,
                          "select-type":
                            _vm.selectTypeNames.basic_data_AllowSaleProduct,
                          filterable: "",
                          no: "allowSaleProduct",
                          clearable: "",
                          "data-filter-function": function(p) {
                            return p.statusEnabled && p.airImportEnabled
                          },
                          "default-value": _vm.job.saleProductCode || ""
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.saleProductCode = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { slot: "fullOrInside" }, slot: "fullOrInside" },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.FullOrInside")))]
                      ),
                      _c("cargo-advance-select", {
                        attrs: {
                          disabled: _vm.readonly,
                          "select-type":
                            _vm.selectTypeNames
                              .local_cache_FullOrInside$FULL_OR_INSIDE,
                          no: "fullOrInside",
                          clearable: "",
                          "default-value": _vm.job.fullOrInside || ""
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.fullOrInside = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                ]
              : _vm._e(),
            _vm.elementDict.customerProperty.slaveVisible
              ? _c(
                  "el-form-item",
                  {
                    attrs: { slot: "customerProperty" },
                    slot: "customerProperty"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.customerProperty.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.customerProperty.label
                      },
                      slot: "label"
                    }),
                    _c(
                      "el-tooltip",
                      {
                        attrs: { content: _vm.customerTip, placement: "bottom" }
                      },
                      [
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.customerLevel.customerName,
                                expression: "customerLevel.customerName"
                              }
                            ],
                            staticClass: "orange"
                          },
                          [_vm._v("LV" + _vm._s(_vm.customerLevel.level))]
                        ),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.customerLevel.customerName,
                                expression: "customerLevel.customerName"
                              }
                            ],
                            staticStyle: { color: "#D3A73B" }
                          },
                          [_vm._v(" " + _vm._s(_vm.customerLevel.customerName))]
                        ),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.contractStatusLabel,
                                expression: "contractStatusLabel"
                              }
                            ],
                            staticClass: "red"
                          },
                          [_vm._v(" (" + _vm._s(_vm.contractStatusLabel) + ")")]
                        ),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.advancePaymentLabel,
                                expression: "advancePaymentLabel"
                              }
                            ],
                            staticStyle: { color: "brown" }
                          },
                          [_vm._v(" (" + _vm._s(_vm.advancePaymentLabel) + ")")]
                        ),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.stampPictureView.businessDocuments
                                    .length > 0,
                                expression:
                                  "stampPictureView.businessDocuments.length > 0"
                              }
                            ],
                            on: {
                              click: function($event) {
                                _vm.stampPictureView.visible = true
                              }
                            }
                          },
                          [
                            _c("img", {
                              staticStyle: { "text-align": "right" },
                              attrs: {
                                title: _vm.$t("Message.BookingSeal"),
                                src: _vm.stampIcon,
                                height: "14"
                              }
                            })
                          ]
                        )
                      ]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.customerContact.slaveVisible
              ? _c(
                  "el-form-item",
                  {
                    attrs: { slot: "customerContact" },
                    slot: "customerContact"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.customerContact.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.customerContact.label
                      },
                      slot: "label"
                    }),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-between"
                        }
                      },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              disabled: _vm.readonly,
                              no: "customerContact",
                              filterable: "",
                              "allow-create": true,
                              placeholder: " "
                            },
                            model: {
                              value: _vm.job.customerContact,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "customerContact", $$v)
                              },
                              expression: "job.customerContact"
                            }
                          },
                          _vm._l(_vm.contactList, function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label: item.contactPerson,
                                value: item.contactPerson
                              }
                            })
                          }),
                          1
                        ),
                        _c(
                          "el-link",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.isShowContactPersonDetail,
                                expression: "!isShowContactPersonDetail"
                              }
                            ],
                            attrs: { no: "Detail" },
                            on: {
                              click: function($event) {
                                _vm.contactInfoDialog.visible = true
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.Detail")))]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.contactTelephone.slaveVisible
              ? _c(
                  "el-form-item",
                  {
                    attrs: { slot: "contactTelephone" },
                    slot: "contactTelephone"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.contactTelephone.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.contactTelephone.label
                      },
                      slot: "label"
                    }),
                    _c("el-input", {
                      attrs: { disabled: _vm.readonly, no: "contactTelephone" },
                      model: {
                        value: _vm.job.contactTelephone,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "contactTelephone", $$v)
                        },
                        expression: "job.contactTelephone"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.contactFax.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "contactFax" }, slot: "contactFax" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.contactFax.isRequire ? "blue" : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.contactFax.label
                      },
                      slot: "label"
                    }),
                    _c("el-input", {
                      attrs: { disabled: _vm.readonly, no: "contactFax" },
                      model: {
                        value: _vm.job.contactFax,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "contactFax", $$v)
                        },
                        expression: "job.contactFax"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.cargoSource.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "cargoSource" }, slot: "cargoSource" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.cargoSource.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.cargoSource.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-advance-select", {
                      attrs: {
                        no: "cargoSource",
                        filterable: "",
                        disabled: _vm.readonly,
                        "select-type":
                          _vm.selectTypeNames.local_cache_CargoSource,
                        "callback-method-type": "value",
                        "default-value": _vm.job.cargoSource,
                        "callback-params": { key: "cargoSource" },
                        clearable: false,
                        placeholder: " "
                      },
                      on: { parentCallBack: _vm.cargoSource_Change }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.customJobType.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "customJobType" }, slot: "customJobType" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.customJobType.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.customJobType.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-advance-select", {
                      ref: "customJobType",
                      attrs: {
                        no: "customJobType",
                        filterable: "",
                        disabled: _vm.readonly,
                        "select-type":
                          _vm.selectTypeNames.basic_data_CutomJobType,
                        "default-value": _vm.job.customJobType,
                        "tag-name": _vm.isZh ? "name" : "englishName",
                        "method-params": { type: _vm.job.lob },
                        "static-options": _vm.customJobTypeList,
                        placeholder: " "
                      },
                      on: {
                        parentCallBack: function(p) {
                          _vm.job.customJobType = p.value
                          _vm.onCustomJobTypeChange(p)
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.secondaryCustomJobType.slaveVisible &&
            _vm.job.customJobType &&
            _vm.secondaryCustomJobTypeList.length > 0
              ? _c(
                  "el-form-item",
                  {
                    attrs: { slot: "secondaryCustomJobType" },
                    slot: "secondaryCustomJobType"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.secondaryCustomJobType.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.secondaryCustomJobType.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-advance-select", {
                      ref: "secondaryCustomJobType",
                      attrs: {
                        no: "secondaryCustomJobType",
                        disabled: _vm.readonly,
                        "select-type":
                          _vm.selectTypeNames.basic_data_CutomJobType,
                        filterable: "",
                        cache: false,
                        "default-value": _vm.job.secondaryCustomJobType,
                        "tag-name": _vm.isZh ? "name" : "englishName",
                        "static-options": _vm.secondaryCustomJobTypeList
                      },
                      on: {
                        parentCallBack: function(p) {
                          _vm.job.secondaryCustomJobType = p.value
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "el-form-item",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.elementDict.designationAgent.slaveVisible &&
                      _vm.job.cargoSource === "NC",
                    expression:
                      "elementDict.designationAgent.slaveVisible && job.cargoSource==='NC'"
                  }
                ],
                attrs: { slot: "designationAgent" },
                slot: "designationAgent"
              },
              [
                _c("line-label", {
                  class: _vm.elementDict.designationAgent.isRequire
                    ? "blue"
                    : "",
                  attrs: {
                    slot: "label",
                    label: _vm.elementDict.designationAgent.label
                  },
                  slot: "label"
                }),
                _c(
                  "div",
                  { staticStyle: { display: "flex", "align-items": "center" } },
                  [
                    _c(
                      "el-tooltip",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.sopImageB,
                            expression: "sopImageB"
                          }
                        ],
                        attrs: {
                          no: "sopImageB",
                          content: _vm.$t("SeaExport.SOPReceiver"),
                          placement: "right-end"
                        }
                      },
                      [
                        _c("div", { staticStyle: { height: "28px" } }, [
                          _c("img", {
                            class:
                              _vm.job.designationAgent && _vm.readonly
                                ? ""
                                : "not-click",
                            staticStyle: {
                              padding: "5px 0",
                              cursor: "pointer"
                            },
                            attrs: { src: _vm.sopPic, width: "18" },
                            on: {
                              click: function($event) {
                                return _vm.showSopReceiverDialog(
                                  "DesignationAgent",
                                  _vm.job.designationAgent
                                )
                              }
                            }
                          })
                        ])
                      ]
                    ),
                    _c(
                      "el-tooltip",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.creditTip.showWarningImageB,
                            expression: "creditTip.showWarningImageB"
                          }
                        ],
                        attrs: {
                          content: _vm.creditTip.warningImageBTip,
                          placement: "right-end"
                        }
                      },
                      [
                        _c("i", {
                          staticClass: "el-icon-warning",
                          staticStyle: {
                            color: "red",
                            "font-size": "18px",
                            cursor: "pointer"
                          }
                        })
                      ]
                    ),
                    _c("cargo-company-select", {
                      staticStyle: { display: "inline-block", width: "100%" },
                      attrs: {
                        no: "designationAgent",
                        disabled: _vm.readonly,
                        "method-params": { overseaAgent: true, active: true },
                        "check-credit": true,
                        job: _vm.job,
                        "default-value": _vm.job.designationAgent || "",
                        "tag-name": "englishName",
                        placeholder: _vm.$t("SeaExport.RequiredItem")
                      },
                      on: { change: _vm.designationAgentChangeHandler }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm.elementDict.salesChannel.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "salesChannel" }, slot: "salesChannel" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.salesChannel.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.salesChannel.label
                      },
                      slot: "label"
                    }),
                    _c("el-input", {
                      attrs: { no: "salesChannel", disabled: true },
                      model: {
                        value: _vm.job.salesChannel,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "salesChannel", $$v)
                        },
                        expression: "job.salesChannel"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.trustFromJob &&
            _vm.elementDict.trustFromJob.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "trustFromJob" }, slot: "trustFromJob" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.trustFromJob.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.trustFromJob.label
                      },
                      slot: "label"
                    }),
                    _c("el-input", {
                      attrs: { no: "trustFromJob", disabled: true },
                      model: {
                        value: _vm.job.trustFromJob,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "trustFromJob", $$v)
                        },
                        expression: "job.trustFromJob"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.relatedJob &&
            _vm.elementDict.relatedJob.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "relatedJob" }, slot: "relatedJob" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.relatedJob.isRequire ? "blue" : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.relatedJob.label
                      },
                      slot: "label"
                    }),
                    _c("el-input", {
                      attrs: { no: "relatedJob", disabled: true },
                      model: {
                        value: _vm.job.relatedJob,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "relatedJob", $$v)
                        },
                        expression: "job.relatedJob"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.loadingAgentId.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "loadingAgentId" }, slot: "loadingAgentId" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.loadingAgentId.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.loadingAgentId.label
                      },
                      slot: "label"
                    }),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center"
                        }
                      },
                      [
                        _c(
                          "el-tooltip",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.sopImageC,
                                expression: "sopImageC"
                              }
                            ],
                            attrs: {
                              no: "sopImageC",
                              content: _vm.$t("SeaExport.SOPReceiver"),
                              placement: "right-end"
                            }
                          },
                          [
                            _c("div", { staticStyle: { height: "28px" } }, [
                              _c("img", {
                                class:
                                  _vm.job.loadingAgentId && _vm.readonly
                                    ? ""
                                    : "not-click",
                                staticStyle: {
                                  padding: "5px 0",
                                  cursor: "pointer"
                                },
                                attrs: { src: _vm.sopPic, width: "18" },
                                on: {
                                  click: function($event) {
                                    return _vm.showSopReceiverDialog(
                                      "PortOfLoadingAgent",
                                      _vm.job.loadingAgentId
                                    )
                                  }
                                }
                              })
                            ])
                          ]
                        ),
                        _c(
                          "el-tooltip",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.creditTip.showWarningImageC,
                                expression: "creditTip.showWarningImageC"
                              }
                            ],
                            attrs: {
                              content: _vm.creditTip.warningImageCTip,
                              placement: "right-end"
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-warning",
                              staticStyle: {
                                color: "red",
                                "font-size": "18px",
                                cursor: "pointer"
                              }
                            })
                          ]
                        ),
                        _c("cargo-company-select", {
                          staticStyle: {
                            display: "inline-block",
                            width: "100%"
                          },
                          attrs: {
                            no: "loadingAgentId",
                            disabled: _vm.readonly,
                            "method-params": {
                              overseaAgent: true,
                              active: true
                            },
                            "check-credit": true,
                            job: _vm.job,
                            "default-value": _vm.job.loadingAgentId || "",
                            "tag-name": "englishName",
                            placeholder: " "
                          },
                          on: { change: _vm.loadingAgentChangeHandler }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.carrierId.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "carrierId" }, slot: "carrierId" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.carrierId.isRequire ? "blue" : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.carrierId.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-advance-select", {
                      attrs: {
                        disabled: _vm.readonly || !_vm.carrierIdEnabled,
                        no: "carrierId",
                        filterable: "",
                        "select-type": _vm.selectTypeNames.basic_data_Company,
                        "method-params": {
                          airCmp: true,
                          companyLob: "airImport",
                          active: true
                        },
                        "callback-params": { key: "carrierId" },
                        "tag-name": "chineseName",
                        "callback-method-type": "value",
                        "default-value": _vm.job.carrierId || "",
                        placeholder: " "
                      },
                      on: {
                        parentCallBack: function(p) {
                          _vm.setJobSelectNum(p)
                          _vm.airlineCompanyChange(p.value || 0)
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.voyageFlight.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "voyageFlight" }, slot: "voyageFlight" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.voyageFlight.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.voyageFlight.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-input", {
                      attrs: {
                        disabled: _vm.readonly || !_vm.isLclMasterFlag,
                        no: "voyageFlight",
                        "auto-uppercase": true
                      },
                      model: {
                        value: _vm.job.voyageFlight,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "voyageFlight", $$v)
                        },
                        expression: "job.voyageFlight"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.bookingAgent.slaveVisible && _vm.bookingAgentVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "bookingAgent" }, slot: "bookingAgent" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.bookingAgent.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.bookingAgent.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-advance-select", {
                      attrs: {
                        no: "bookingAgent",
                        filterable: "",
                        disabled: _vm.readonly,
                        "select-type": _vm.selectTypeNames.basic_data_Company,
                        "method-params": {
                          bookingAgent: true,
                          companyLob: "airImport",
                          active: true
                        },
                        "callback-params": { key: "bookingAgent" },
                        "callback-method-type": "value",
                        "default-value": _vm.job.bookingAgent || "",
                        placeholder: " "
                      },
                      on: {
                        parentCallBack: function(obj) {
                          _vm.setJobSelectNum(obj)
                          _vm.job.groundAgentId = _vm.job.bookingAgent
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.exChangeAgent.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "exChangeAgent" }, slot: "exChangeAgent" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.exChangeAgent.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.exChangeAgent.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-advance-select", {
                      attrs: {
                        no: "exChangeAgent",
                        filterable: "",
                        disabled: _vm.readonly,
                        "select-type": _vm.selectTypeNames.basic_data_Company,
                        "method-params": {
                          bookingAgent: true,
                          companyLob: "airImport",
                          active: true
                        },
                        "callback-params": { key: "exChangeAgent" },
                        "callback-method-type": "value",
                        "default-value": _vm.job.exChangeAgent || "",
                        placeholder: " "
                      },
                      on: {
                        parentCallBack: function(obj) {
                          _vm.setJobSelectNum(obj)
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.mbl.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "mbl" }, slot: "mbl" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.mbl.isRequire ? "blue" : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.mbl.label
                      },
                      slot: "label"
                    }),
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content:
                            _vm.job.express || _vm.mblCodeNumValidate
                              ? ""
                              : _vm.$t("queryJob.TheDoesNotComplyRules"),
                          placement: "right-end"
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c(
                              "el-checkbox",
                              {
                                attrs: {
                                  disabled: _vm.readonly,
                                  no: "express"
                                },
                                model: {
                                  value: _vm.job.express,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "express", $$v)
                                  },
                                  expression: "job.express"
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.ExpressInfo")))]
                            ),
                            _c("cargo-input", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.job.express,
                                  expression: "job.express"
                                }
                              ],
                              staticStyle: { "flex-grow": "1" },
                              attrs: {
                                disabled: _vm.readonly,
                                no: "mbl",
                                maxlength: 32,
                                "auto-uppercase": true
                              },
                              model: {
                                value: _vm.job.mbl,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "mbl", $$v)
                                },
                                expression: "job.mbl"
                              }
                            }),
                            _c("el-input", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.job.express,
                                  expression: "!job.express"
                                }
                              ],
                              ref: "mblCode",
                              class: _vm.mblCodeNumValidate ? "" : "red",
                              staticStyle: { width: "80px", "flex-grow": "1" },
                              attrs: {
                                value: _vm.mblCode,
                                disabled: _vm.readonly || !_vm.isLclMasterFlag,
                                no: "mblCode",
                                maxlength: "3"
                              },
                              on: {
                                input: _vm.onMblCodeInput,
                                blur: _vm.onMblCodeNumBlur
                              }
                            }),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.job.express,
                                    expression: "!job.express"
                                  }
                                ],
                                staticStyle: {
                                  "padding-right": "2px",
                                  "padding-left": "1.5px"
                                }
                              },
                              [_vm._v("-")]
                            ),
                            _c("cargo-input", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.job.express,
                                  expression: "!job.express"
                                }
                              ],
                              ref: "mblNum",
                              class: _vm.mblCodeNumValidate ? "" : "red",
                              staticStyle: { width: "150px", "flex-grow": "1" },
                              attrs: {
                                value: _vm.mblNum,
                                disabled: _vm.readonly || !_vm.isLclMasterFlag,
                                no: "mblNum",
                                maxlength: 8,
                                "input-convert": _vm.filterNonDigit
                              },
                              on: {
                                input: _vm.onMblNumInput,
                                blur: _vm.onMblCodeNumBlur
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.jobSoNo.slaveVisible
              ? _c(
                  "el-form-item",
                  {
                    staticStyle: { "margin-right": "-3px" },
                    attrs: { slot: "jobSoNo" },
                    slot: "jobSoNo"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.jobSoNo.isRequire ? "blue" : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.jobSoNo.label
                      },
                      slot: "label"
                    }),
                    _c("so-no-input", {
                      attrs: { disabled: _vm.readonly, no: "jobSoNo" },
                      model: {
                        value: _vm.job.jobSoNo,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "jobSoNo", $$v)
                        },
                        expression: "job.jobSoNo"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.hbl.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "hbl" }, slot: "hbl" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.hbl.isRequire ? "blue" : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.hbl.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-input", {
                      attrs: {
                        disabled: _vm.readonly,
                        no: "hbl",
                        "auto-uppercase": true
                      },
                      model: {
                        value: _vm.job.hbl,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "hbl", $$v)
                        },
                        expression: "job.hbl"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.dispatchingPlace.slaveVisible
              ? _c(
                  "el-form-item",
                  {
                    attrs: { slot: "dispatchingPlace" },
                    slot: "dispatchingPlace"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.dispatchingPlace.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.dispatchingPlace.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-input", {
                      attrs: {
                        disabled: _vm.readonly,
                        no: "dispatchingPlace",
                        "auto-uppercase": true
                      },
                      model: {
                        value: _vm.job.dispatchingPlace,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "dispatchingPlace", $$v)
                        },
                        expression: "job.dispatchingPlace"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.loadingPortCode.slaveVisible
              ? _c(
                  "el-form-item",
                  {
                    attrs: { slot: "loadingPortCode" },
                    slot: "loadingPortCode"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.loadingPortCode.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.loadingPortCode.label
                      },
                      slot: "label"
                    }),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-between"
                        }
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "60px", "margin-right": "5px" },
                          attrs: { disabled: true, no: "loadingPortCode" },
                          model: {
                            value: _vm.job.loadingPortCode,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "loadingPortCode", $$v)
                            },
                            expression: "job.loadingPortCode"
                          }
                        }),
                        _c("cargo-advance-select", {
                          staticStyle: { flex: "1" },
                          attrs: {
                            no: "loadingPortCode",
                            filterable: "",
                            disabled: _vm.readonly,
                            "select-type":
                              _vm.selectTypeNames.basic_data_Airport,
                            "default-value": _vm.valueMatch.loadingPortCode
                              ? _vm.job.loadingPortCode
                              : "",
                            placeholder: _vm.$t("SeaExport.RequiredItem")
                          },
                          on: {
                            parentCallBack: function(obj) {
                              _vm.valueMatch.loadingPortCode = true
                              _vm.loadingPortCodeChange(obj)
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.dischargingPortCode.slaveVisible
              ? _c(
                  "el-form-item",
                  {
                    attrs: { slot: "dischargingPortCode" },
                    slot: "dischargingPortCode"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.dischargingPortCode.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.dischargingPortCode.label
                      },
                      slot: "label"
                    }),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-between"
                        }
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "60px", "margin-right": "5px" },
                          attrs: { disabled: true, no: "dischargingPortCode" },
                          model: {
                            value: _vm.job.dischargingPortCode,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "dischargingPortCode", $$v)
                            },
                            expression: "job.dischargingPortCode"
                          }
                        }),
                        _c("cargo-advance-select", {
                          staticStyle: { flex: "1" },
                          attrs: {
                            no: "dischargingPortCode",
                            filterable: "",
                            disabled: _vm.readonly,
                            "select-type":
                              _vm.selectTypeNames.basic_data_Airport,
                            "default-value": _vm.valueMatch.dischargingPortCode
                              ? _vm.job.dischargingPortCode
                              : "",
                            placeholder: _vm.$t("SeaExport.RequiredItem")
                          },
                          on: { parentCallBack: _vm.dischargingPortCode_Change }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.destinationPlace.slaveVisible
              ? _c(
                  "el-form-item",
                  {
                    attrs: { slot: "destinationPlace" },
                    slot: "destinationPlace"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.destinationPlace.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.destinationPlace.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-input", {
                      attrs: {
                        disabled: _vm.readonly,
                        no: "destinationPlace",
                        "auto-uppercase": true,
                        placeholder: _vm.$t("SeaExport.RequiredItem")
                      },
                      model: {
                        value: _vm.job.destinationPlace,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "destinationPlace", $$v)
                        },
                        expression: "job.destinationPlace"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.regionName.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "regionName" }, slot: "regionName" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.regionName.isRequire ? "blue" : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.regionName.label
                      },
                      slot: "label"
                    }),
                    _c("el-input", {
                      attrs: { no: "airline", disabled: true },
                      model: {
                        value: _vm.job.regionName,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "regionName", $$v)
                        },
                        expression: "job.regionName"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.customsBroker.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "customsBroker" }, slot: "customsBroker" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.customsBroker.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.customsBroker.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-advance-select", {
                      attrs: {
                        disabled: _vm.readonly || !_vm.job.customs,
                        no: "customsBroker",
                        filterable: "",
                        "select-type": _vm.selectTypeNames.basic_data_Company,
                        "method-params": { customsBroker: true, active: true },
                        "callback-method-type": "value",
                        "default-value": _vm.job.customsBroker || "",
                        placeholder: " ",
                        "callback-params": { key: "customsBroker" }
                      },
                      on: { parentCallBack: _vm.setJobSelectNum }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.customClaim.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "customClaim" }, slot: "customClaim" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.customClaim.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.customClaim.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-advance-select", {
                      attrs: {
                        no: "customsMethod",
                        disabled: _vm.readonly || !_vm.job.customs,
                        "select-type":
                          _vm.selectTypeNames.basic_data_CustomsMode,
                        "method-params": { serviceType: 2 },
                        "tag-value": "serialNum",
                        filterable: "",
                        "default-value": _vm.job.customClaim
                      },
                      on: {
                        parentCallBack: function(p) {
                          _vm.job.customClaim = p.value
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.customsDeclarationType.slaveVisible &&
            _vm.job.customClaim === 1
              ? _c(
                  "el-form-item",
                  {
                    attrs: { slot: "customsDeclarationType" },
                    slot: "customsDeclarationType"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.customsDeclarationType.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.customsDeclarationType.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-advance-select", {
                      attrs: {
                        no: "customsDeclarationType",
                        disabled: _vm.readonly || !_vm.job.customs,
                        "select-type":
                          _vm.selectTypeNames.basic_data_CustomsDeclarationType,
                        filterable: "",
                        "default-value":
                          _vm.job.customsDeclarationType === -1
                            ? ""
                            : _vm.job.customsDeclarationType,
                        placeholder: _vm.$t("CargoMsg.Cargo_keyWordsTip")
                      },
                      on: {
                        parentCallBack: function(p) {
                          _vm.job.customsDeclarationType = p.value
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.tradeTerm.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "tradeTerm" }, slot: "tradeTerm" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.tradeTerm.isRequire ? "blue" : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.tradeTerm.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-advance-select", {
                      attrs: {
                        no: "tradeTerm",
                        filterable: "",
                        disabled: _vm.readonly,
                        "select-type": _vm.selectTypeNames.basic_data_TradeTerm,
                        "callback-method-type": "value",
                        "default-value": _vm.job.tradeTerm,
                        "callback-params": { key: "tradeTerm" },
                        clearable: false
                      },
                      on: { parentCallBack: _vm.setJobSelectValue }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.cargoCode.slaveVisible
              ? _c(
                  "template",
                  { slot: "cargoCode" },
                  [
                    _c(
                      "el-form-item",
                      [
                        _c("line-label", {
                          class: _vm.elementDict.cargoCode.isRequire
                            ? "blue"
                            : "",
                          attrs: {
                            slot: "label",
                            label: _vm.elementDict.cargoCode.label
                          },
                          slot: "label"
                        }),
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "cargoCode",
                            disabled: _vm.readonly,
                            "select-type":
                              _vm.selectTypeNames.basic_data_CargoInformation,
                            filterable: "",
                            "callback-params": { key: "cargoCode" },
                            "default-value": _vm.job.cargoCode,
                            placeholder: " "
                          },
                          on: {
                            parentCallBack: _vm.txtCargoInformationChangeHandler
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c("cargo-input", {
                          attrs: {
                            disabled: _vm.readonly || !_vm.job.cargoCode,
                            no: "cargoName"
                          },
                          model: {
                            value: _vm.job.cargoName,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "cargoName", $$v)
                            },
                            expression: "job.cargoName"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.deliveryAddress.slaveVisible
              ? _c(
                  "el-form-item",
                  {
                    attrs: { slot: "deliveryAddress" },
                    slot: "deliveryAddress"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.deliveryAddress.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.deliveryAddress.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-rich-textarea", {
                      staticStyle: { height: "110px" },
                      attrs: { no: "deliveryAddress", disabled: _vm.readonly },
                      nativeOn: {
                        dblclick: function($event) {
                          _vm.showAdvanceTextDialog(
                            _vm.$t("Message.TerminalAddress"),
                            _vm.job.deliveryAddress,
                            undefined,
                            function(val) {
                              _vm.job.deliveryAddress = val
                            }
                          )
                        }
                      },
                      model: {
                        value: _vm.job.deliveryAddress,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "deliveryAddress", $$v)
                        },
                        expression: "job.deliveryAddress"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.transportSource.slaveVisible
              ? _c(
                  "el-form-item",
                  {
                    attrs: { slot: "transportSource" },
                    slot: "transportSource"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.transportSource.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.transportSource.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-advance-select", {
                      attrs: {
                        filterable: "",
                        disabled: _vm.readonly,
                        "select-type":
                          _vm.selectTypeNames.basic_data_TransportSource,
                        no: "transportSource",
                        "default-value": _vm.job.transportSource,
                        cache: false,
                        "tag-value": "code",
                        placeholder: " "
                      },
                      on: {
                        parentCallBack: function(item) {
                          return (_vm.job.transportSource = item.value)
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.statisticArea.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "statisticArea" }, slot: "statisticArea" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.statisticArea.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.statisticArea.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-advance-select", {
                      attrs: {
                        filterable: "",
                        disabled: _vm.readonly,
                        "select-type":
                          _vm.selectTypeNames.basic_data_StatisticArea,
                        no: "statisticArea",
                        "default-value": _vm.job.statisticArea,
                        cache: false,
                        "tag-value": "code",
                        placeholder: " "
                      },
                      on: {
                        parentCallBack: function(item) {
                          return (_vm.job.statisticArea = item.value)
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.customsDate.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "customsDate" }, slot: "customsDate" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.customsDate.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.customsDate.label
                      },
                      slot: "label"
                    }),
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        disabled: _vm.readonly,
                        no: "customsDate",
                        type: "date",
                        "value-format": "yyyy-MM-dd",
                        clearable: ""
                      },
                      model: {
                        value: _vm.job.customsDate,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "customsDate", $$v)
                        },
                        expression: "job.customsDate"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.etd.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "etd" }, slot: "etd" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.etd.isRequire ? "blue" : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.etd.label
                      },
                      slot: "label"
                    }),
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("el-date-picker", {
                          staticStyle: {
                            flex: "1",
                            width: "170px",
                            "margin-right": "5px"
                          },
                          attrs: {
                            "default-value": new Date(),
                            disabled: _vm.readonly || !_vm.isLclMasterFlag,
                            no: "etd",
                            type: "datetime",
                            format: "yyyy-MM-dd HH:mm",
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                            placeholder: "",
                            clearable: ""
                          },
                          on: { input: _vm.etdChange },
                          model: {
                            value: _vm.job.etd,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "etd", $$v)
                            },
                            expression: "job.etd"
                          }
                        }),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm._f("filterWeek")(_vm.job.sailingDay))
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.eta.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "eta" }, slot: "eta" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.eta.isRequire ? "blue" : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.eta.label
                      },
                      slot: "label"
                    }),
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("el-date-picker", {
                          staticStyle: {
                            flex: "1",
                            width: "170px",
                            "margin-right": "5px"
                          },
                          attrs: {
                            "default-value": new Date(),
                            disabled: _vm.readonly || !_vm.isLclMasterFlag,
                            no: "eta",
                            type: "datetime",
                            format: "yyyy-MM-dd HH:mm",
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                            placeholder: _vm.$t("SeaExport.RequiredItem"),
                            clearable: ""
                          },
                          on: { change: _vm.etaChange },
                          model: {
                            value: _vm.job.eta,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "eta", $$v)
                            },
                            expression: "job.eta"
                          }
                        }),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm._f("filterWeek")(_vm.job.etaSailingDay))
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.atd.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "atd" }, slot: "atd" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.atd.isRequire ? "blue" : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.atd.label
                      },
                      slot: "label"
                    }),
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("el-date-picker", {
                          staticStyle: {
                            flex: "1",
                            width: "170px",
                            "margin-right": "5px"
                          },
                          attrs: {
                            "default-value": new Date(),
                            disabled: _vm.readonly || !_vm.isLclMasterFlag,
                            no: "atd",
                            type: "datetime",
                            format: "yyyy-MM-dd HH:mm",
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                            clearable: ""
                          },
                          on: { input: _vm.atdChange },
                          model: {
                            value: _vm.job.atd,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "atd", $$v)
                            },
                            expression: "job.atd"
                          }
                        }),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm._f("filterWeek")(_vm.job.atdSailingDay))
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.ata.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "ata" }, slot: "ata" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.ata.isRequire ? "blue" : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.ata.label
                      },
                      slot: "label"
                    }),
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("el-date-picker", {
                          staticStyle: {
                            flex: "1",
                            width: "170px",
                            "margin-right": "5px"
                          },
                          attrs: {
                            "default-value": new Date(),
                            disabled: _vm.readonly || !_vm.isLclMasterFlag,
                            no: "ata",
                            type: "datetime",
                            format: "yyyy-MM-dd HH:mm",
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                            clearable: ""
                          },
                          on: { input: _vm.ataChange },
                          model: {
                            value: _vm.job.ata,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "ata", $$v)
                            },
                            expression: "job.ata"
                          }
                        }),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm._f("filterWeek")(_vm.job.ataSailingDay))
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.shipper.slaveVisible
              ? _c(
                  "template",
                  { slot: "shipper" },
                  [
                    _c("el-form-item", [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "flex-end"
                          }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                disabled: _vm.readonly,
                                no: "CopyFromOtherBill"
                              },
                              on: {
                                click: function($event) {
                                  _vm.importPromptTitleDialog.visible = true
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.CopyFromOtherBill"))
                              )
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                disabled: _vm.readonly,
                                no: "CodeSearching"
                              },
                              on: {
                                click: function($event) {
                                  _vm.billAddressDialog.visible = true
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.CodeSearching")))]
                          )
                        ],
                        1
                      )
                    ]),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "template",
                          { slot: "label" },
                          [
                            _c("line-label", {
                              class: _vm.elementDict.shipper.isRequire
                                ? "blue"
                                : "",
                              attrs: { label: _vm.elementDict.shipper.label }
                            }),
                            _c("char-count", {
                              staticStyle: {
                                position: "static",
                                display: "block",
                                "font-size": "10px",
                                color: "#909399"
                              },
                              attrs: { form: _vm.job, prefix: "shipper" }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-between",
                              "margin-bottom": "10px"
                            }
                          },
                          [
                            _c("cargo-input", {
                              staticStyle: {
                                width: "90px",
                                "margin-right": "5px"
                              },
                              attrs: {
                                disabled: _vm.readonly,
                                no: "shipperCode",
                                "auto-uppercase": true,
                                placeholder: _vm.readonly
                                  ? ""
                                  : _vm.$t("Tool.Code")
                              },
                              on: {
                                change: function($event) {
                                  return _vm.syncHbl("shipperCode")
                                }
                              },
                              model: {
                                value: _vm.job.shipperCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "shipperCode", $$v)
                                },
                                expression: "job.shipperCode"
                              }
                            }),
                            _c("cargo-advance-select", {
                              staticStyle: { flex: "1" },
                              attrs: {
                                no: "shipperId",
                                filterable: "",
                                disabled: _vm.readonly,
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Company,
                                "method-params": {
                                  shipper: true,
                                  active: true
                                },
                                "default-value": _vm.job.shipperId || "",
                                "tag-name": "englishName",
                                placeholder: " "
                              },
                              on: {
                                parentCallBack: _vm.shipperAutoCompleteChange
                              }
                            })
                          ],
                          1
                        )
                      ],
                      2
                    ),
                    _vm._l(1, function(i) {
                      return i >= 1
                        ? _c(
                            "el-form-item",
                            {
                              key: "shipperLine" + i,
                              staticStyle: { "margin-top": "-10px" }
                            },
                            [
                              _c("cargo-input", {
                                ref: "shipperLine" + i,
                                refInFor: true,
                                attrs: {
                                  disabled: _vm.readonly,
                                  no: "shipperLine1",
                                  "auto-uppercase": true,
                                  "use-read-only": true,
                                  placeholder: _vm.readonly
                                    ? ""
                                    : _vm.$t("queryJob.DoubleOfLadingHeaderUp")
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.syncHbl("shipperLine1")
                                  }
                                },
                                nativeOn: {
                                  dblclick: function($event) {
                                    _vm.showAdvanceTextDialog(
                                      _vm.$t("SeaExport.Shipper"),
                                      _vm.mergeShipperLine(),
                                      undefined,
                                      _vm.splitShipperLine
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.job["shipperLine" + i],
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "shipperLine" + i, $$v)
                                  },
                                  expression: "job['shipperLine'+i]"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    }),
                    _vm._l(7, function(i) {
                      return i >= 2
                        ? _c(
                            "el-form-item",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: false,
                                  expression: "false"
                                }
                              ],
                              key: "shipperLine" + i
                            },
                            [
                              _c("cargo-input", {
                                ref: "shipperLine" + i,
                                refInFor: true,
                                attrs: {
                                  disabled: _vm.readonly,
                                  "use-read-only": true,
                                  no: "'shipperLine'+i"
                                },
                                model: {
                                  value: _vm.job["shipperLine" + i],
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "shipperLine" + i, $$v)
                                  },
                                  expression: "job['shipperLine'+i]"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    })
                  ],
                  2
                )
              : _vm._e(),
            _vm.elementDict.consignee.slaveVisible
              ? _c(
                  "template",
                  { slot: "consignee" },
                  [
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "template",
                          { slot: "label" },
                          [
                            _c("line-label", {
                              class: _vm.elementDict.consignee.isRequire
                                ? "blue"
                                : "",
                              attrs: { label: _vm.elementDict.consignee.label }
                            }),
                            _c("char-count", {
                              staticStyle: {
                                position: "static",
                                display: "block",
                                "font-size": "10px",
                                color: "#909399"
                              },
                              attrs: { form: _vm.job, prefix: "consignee" }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-between",
                              "margin-bottom": "10px"
                            }
                          },
                          [
                            _c("cargo-input", {
                              staticStyle: {
                                width: "90px",
                                "margin-right": "5px"
                              },
                              attrs: {
                                disabled: _vm.readonly,
                                no: "consigneeCode",
                                "auto-uppercase": true,
                                placeholder: _vm.readonly
                                  ? ""
                                  : _vm.$t("Tool.Code")
                              },
                              on: {
                                change: function($event) {
                                  return _vm.syncHbl("consigneeCode")
                                }
                              },
                              model: {
                                value: _vm.job.consigneeCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "consigneeCode", $$v)
                                },
                                expression: "job.consigneeCode"
                              }
                            }),
                            _c("cargo-advance-select", {
                              staticStyle: { flex: "1" },
                              attrs: {
                                no: "consigneeId",
                                filterable: "",
                                disabled: _vm.readonly,
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Company,
                                "method-params": { consignee: true },
                                "default-value": _vm.job.consigneeId || "",
                                "tag-name": "englishName",
                                placeholder: " "
                              },
                              on: {
                                parentCallBack: _vm.consigneeAutoCompleteChange
                              }
                            })
                          ],
                          1
                        )
                      ],
                      2
                    ),
                    _vm._l(1, function(i) {
                      return i >= 1
                        ? _c(
                            "el-form-item",
                            {
                              key: "consigneeLine" + i,
                              staticStyle: { "margin-top": "-10px" }
                            },
                            [
                              _c("cargo-input", {
                                ref: "consigneeLine" + i,
                                refInFor: true,
                                attrs: {
                                  disabled: _vm.readonly,
                                  no: "consigneeLine1",
                                  "auto-uppercase": true,
                                  "use-read-only": true,
                                  placeholder: _vm.readonly
                                    ? ""
                                    : _vm.$t("queryJob.DoubleOfLadingHeaderUp")
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.syncHbl("consigneeLine1")
                                  }
                                },
                                nativeOn: {
                                  dblclick: function($event) {
                                    _vm.showAdvanceTextDialog(
                                      _vm.$t("SeaExport.Consignee"),
                                      _vm.mergeConsigneeLine(),
                                      undefined,
                                      _vm.splitConsigneeLine
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.job["consigneeLine" + i],
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "consigneeLine" + i, $$v)
                                  },
                                  expression: "job['consigneeLine'+i]"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    }),
                    _vm._l(7, function(i) {
                      return i > 1
                        ? _c(
                            "el-form-item",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: false,
                                  expression: "false"
                                }
                              ],
                              key: "consigneeLine" + i
                            },
                            [
                              _c("cargo-input", {
                                ref: "consigneeLine" + i,
                                refInFor: true,
                                attrs: {
                                  disabled: _vm.readonly,
                                  "use-read-only": true,
                                  no: "'consigneeLine'+i"
                                },
                                model: {
                                  value: _vm.job["consigneeLine" + i],
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "consigneeLine" + i, $$v)
                                  },
                                  expression: "job['consigneeLine'+i]"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    })
                  ],
                  2
                )
              : _vm._e(),
            _vm.elementDict.notify.slaveVisible
              ? _c(
                  "template",
                  { slot: "notify" },
                  [
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "template",
                          { slot: "label" },
                          [
                            _c("line-label", {
                              class: _vm.elementDict.notify.isRequire
                                ? "blue"
                                : "",
                              attrs: { label: _vm.elementDict.notify.label }
                            }),
                            _c("char-count", {
                              staticStyle: {
                                position: "static",
                                display: "block",
                                "font-size": "10px",
                                color: "#909399"
                              },
                              attrs: { form: _vm.job, prefix: "notify" }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-between",
                              "margin-bottom": "10px"
                            }
                          },
                          [
                            _c("cargo-input", {
                              staticStyle: {
                                width: "90px",
                                "margin-right": "5px"
                              },
                              attrs: {
                                disabled: _vm.readonly,
                                no: "notifyCode",
                                "auto-uppercase": true,
                                placeholder: _vm.readonly
                                  ? ""
                                  : _vm.$t("Tool.Code")
                              },
                              on: {
                                change: function($event) {
                                  return _vm.syncHbl("notifyCode")
                                }
                              },
                              model: {
                                value: _vm.job.notifyCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "notifyCode", $$v)
                                },
                                expression: "job.notifyCode"
                              }
                            }),
                            _c("cargo-advance-select", {
                              staticStyle: { flex: "1" },
                              attrs: {
                                no: "notifyId",
                                filterable: "",
                                disabled: _vm.readonly,
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Company,
                                "method-params": { notify: true },
                                "default-value": _vm.job.notifyId || "",
                                "tag-name": "englishName",
                                placeholder: " "
                              },
                              on: {
                                parentCallBack: _vm.notifyAutoCompleteChange
                              }
                            })
                          ],
                          1
                        )
                      ],
                      2
                    ),
                    _vm._l(1, function(i) {
                      return i >= 1
                        ? _c(
                            "el-form-item",
                            {
                              key: "notifyLine" + i,
                              staticStyle: { "margin-top": "-10px" }
                            },
                            [
                              _c("cargo-input", {
                                ref: "notifyLine" + i,
                                refInFor: true,
                                attrs: {
                                  disabled: _vm.readonly,
                                  no: "notifyLine1",
                                  "auto-uppercase": true,
                                  "use-read-only": true,
                                  placeholder: _vm.readonly
                                    ? ""
                                    : _vm.$t("queryJob.DoubleOfLadingHeaderUp")
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.syncHbl("notifyLine1")
                                  }
                                },
                                nativeOn: {
                                  dblclick: function($event) {
                                    _vm.showAdvanceTextDialog(
                                      _vm.$t("SeaExport.NotifyParty"),
                                      _vm.mergeNotifyLine(),
                                      undefined,
                                      _vm.splitNotifyLine
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.job["notifyLine" + i],
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "notifyLine" + i, $$v)
                                  },
                                  expression: "job['notifyLine'+i]"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    }),
                    _vm._l(7, function(i) {
                      return i > 1
                        ? _c(
                            "el-form-item",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: false,
                                  expression: "false"
                                }
                              ],
                              key: "notifyLine" + i
                            },
                            [
                              _c("cargo-input", {
                                ref: "notifyLine" + i,
                                refInFor: true,
                                attrs: {
                                  disabled: _vm.readonly,
                                  "use-read-only": true,
                                  no: "'notifyLine'+i"
                                },
                                model: {
                                  value: _vm.job["notifyLine" + i],
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "notifyLine" + i, $$v)
                                  },
                                  expression: "job['notifyLine'+i]"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    })
                  ],
                  2
                )
              : _vm._e(),
            _vm.elementDict.quantityActual.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "quantityActual" }, slot: "quantityActual" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.quantityActual.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.quantityActual.label
                      },
                      slot: "label"
                    }),
                    _c("auto-number-input", {
                      attrs: {
                        disabled: _vm.readonly,
                        no: "quantityContract",
                        precision: 0,
                        min: 0
                      },
                      on: { change: _vm.quantityChange },
                      model: {
                        value: _vm.job.quantityActual,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "quantityActual", $$v)
                        },
                        expression: "job.quantityActual"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.packing.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "packing" }, slot: "packing" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.packing.isRequire ? "blue" : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.packing.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-packing-select", {
                      attrs: {
                        no: "packing",
                        disabled: _vm.readonly,
                        "default-value": _vm.job.packing,
                        placeholder: " "
                      },
                      on: {
                        change: function(p) {
                          p.key = "packing"
                          _vm.setJobSelectValue(p)
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.weightActual.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "weightActual" }, slot: "weightActual" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.weightActual.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.weightActual.label
                      },
                      slot: "label"
                    }),
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("auto-number-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "weightContract",
                            precision: 3,
                            min: 0
                          },
                          on: { change: _vm.weightContractChange },
                          model: {
                            value: _vm.job.weightActual,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "weightActual", $$v)
                            },
                            expression: "job.weightActual"
                          }
                        }),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "font-size": "12px",
                              "font-weight": "normal",
                              color: "#404144"
                            }
                          },
                          [_c("span", [_vm._v("KGS")])]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.cubageActual.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "cubageActual" }, slot: "cubageActual" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.cubageActual.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.cubageActual.label
                      },
                      slot: "label"
                    }),
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("auto-number-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "cubageContract",
                            precision: 3,
                            min: 0
                          },
                          on: { change: _vm.cubageContractChange },
                          model: {
                            value: _vm.job.cubageActual,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "cubageActual", $$v)
                            },
                            expression: "job.cubageActual"
                          }
                        }),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "font-size": "12px",
                              "font-weight": "normal",
                              color: "#404144"
                            }
                          },
                          [_c("span", [_vm._v("CBM")])]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.chargeWeight.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "chargeWeight" }, slot: "chargeWeight" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.chargeWeight.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.chargeWeight.label
                      },
                      slot: "label"
                    }),
                    _c("auto-number-input", {
                      attrs: {
                        disabled: _vm.readonly,
                        no: "chargeWeight",
                        precision: 3,
                        min: 0
                      },
                      on: {
                        change: function($event) {
                          _vm.syncChargeWeightToCharge()
                          _vm.syncHbl("chargeWeight", "cWeight")
                        }
                      },
                      model: {
                        value: _vm.job.chargeWeight,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "chargeWeight", $$v)
                        },
                        expression: "job.chargeWeight"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.cargoChineseName.slaveVisible
              ? _c(
                  "el-form-item",
                  {
                    attrs: { slot: "cargoChineseName" },
                    slot: "cargoChineseName"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.cargoChineseName.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.cargoChineseName.label
                      },
                      slot: "label"
                    }),
                    _c(
                      "div",
                      { staticStyle: { position: "relative" } },
                      [
                        _c("cargo-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "cargoChineseName",
                            type: "textarea",
                            rows: 3,
                            "auto-uppercase": true
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              return _vm.showAdvanceTextDialog(
                                _vm.elementDict.cargoChineseName.label,
                                _vm.job.cargoChineseName,
                                0,
                                function(val) {
                                  _vm.job.cargoChineseName = val
                                }
                              )
                            }
                          },
                          model: {
                            value: _vm.job.cargoChineseName,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "cargoChineseName", $$v)
                            },
                            expression: "job.cargoChineseName"
                          }
                        }),
                        _c("char-count", {
                          attrs: { value: _vm.job.cargoChineseName }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.cargoEnglishName.slaveVisible
              ? _c(
                  "el-form-item",
                  {
                    attrs: { slot: "cargoEnglishName" },
                    slot: "cargoEnglishName"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.cargoEnglishName.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.cargoEnglishName.label
                      },
                      slot: "label"
                    }),
                    _c(
                      "div",
                      { staticStyle: { position: "relative" } },
                      [
                        _c("cargo-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "cargoEnglishName",
                            type: "textarea",
                            rows: 3,
                            "auto-uppercase": _vm.isUppercaseByConfig
                          },
                          on: {
                            change: function($event) {
                              return _vm.syncHbl("cargoEnglishName")
                            }
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              return _vm.showAdvanceTextDialog(
                                _vm.elementDict.cargoEnglishName.label,
                                _vm.job.cargoEnglishName,
                                0,
                                function(val) {
                                  _vm.job.cargoEnglishName = val
                                },
                                _vm.isUppercaseByConfig
                              )
                            }
                          },
                          model: {
                            value: _vm.job.cargoEnglishName,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "cargoEnglishName", $$v)
                            },
                            expression: "job.cargoEnglishName"
                          }
                        }),
                        _c("char-count", {
                          attrs: { value: _vm.job.cargoEnglishName }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.mark.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "mark" }, slot: "mark" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.mark.isRequire ? "blue" : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.mark.label
                      },
                      slot: "label"
                    }),
                    _c(
                      "div",
                      { staticStyle: { position: "relative" } },
                      [
                        _c("cargo-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "mark",
                            type: "textarea",
                            rows: 3,
                            "auto-uppercase": _vm.isUppercaseByConfig
                          },
                          on: {
                            change: function($event) {
                              return _vm.syncHbl("mark", "remark1")
                            }
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              return _vm.showAdvanceTextDialog(
                                _vm.elementDict.mark.label,
                                _vm.job.mark,
                                0,
                                function(val) {
                                  _vm.job.mark = val
                                },
                                _vm.isUppercaseByConfig
                              )
                            }
                          },
                          model: {
                            value: _vm.job.mark,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "mark", $$v)
                            },
                            expression: "job.mark"
                          }
                        }),
                        _c("char-count", { attrs: { value: _vm.job.mark } })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.depositReceived.slaveVisible
              ? _c(
                  "el-form-item",
                  {
                    attrs: { slot: "depositReceived" },
                    slot: "depositReceived"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.depositReceived.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.depositReceived.label
                      },
                      slot: "label"
                    }),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-between"
                        }
                      },
                      [
                        _c("el-input-number", {
                          staticStyle: { "flex-grow": "1" },
                          attrs: {
                            disabled: _vm.readonly,
                            no: "depositReceived",
                            controls: false,
                            precision: 3
                          },
                          model: {
                            value: _vm.job.depositReceived,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "depositReceived", $$v)
                            },
                            expression: "job.depositReceived"
                          }
                        }),
                        _c("span", [_vm._v(_vm._s(_vm.localCurrency))])
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.remarks.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "remarks" }, slot: "remarks" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.remarks.isRequire ? "blue" : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.remarks.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-input", {
                      attrs: {
                        disabled: _vm.readonly,
                        no: "remarks",
                        type: "textarea",
                        rows: 3,
                        "auto-uppercase": true
                      },
                      nativeOn: {
                        dblclick: function($event) {
                          return _vm.showAdvanceTextDialog(
                            _vm.elementDict.remarks.label,
                            _vm.job.remarks,
                            0,
                            function(val) {
                              _vm.job.remarks = val
                            }
                          )
                        }
                      },
                      model: {
                        value: _vm.job.remarks,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "remarks", $$v)
                        },
                        expression: "job.remarks"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.poNo.slaveVisible
              ? _c(
                  "el-form-item",
                  {
                    class: _vm.poNoRed ? "poNoClass" : "",
                    attrs: { slot: "poNo" },
                    slot: "poNo"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.poNo.isRequire ? "blue" : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.poNo.label
                      },
                      slot: "label"
                    }),
                    !_vm.openProjectConfig
                      ? _c("cargo-input", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "poNo",
                            "auto-uppercase": true
                          },
                          model: {
                            value: _vm.job.poNo,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "poNo", $$v)
                            },
                            expression: "job.poNo"
                          }
                        })
                      : _vm._e(),
                    _vm.openProjectConfig
                      ? _c("cargo-project-select", {
                          attrs: {
                            disabled: _vm.readonly,
                            no: "poNo",
                            "default-value": _vm.job.poNo,
                            "customer-id": _vm.job.customerId
                          },
                          on: { change: _vm.changeProject }
                        })
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.projectName.slaveVisible && _vm.openProjectConfig
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "projectName" }, slot: "projectName" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.projectName.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.projectName.label
                      },
                      slot: "label"
                    }),
                    _c("el-input", {
                      attrs: { disabled: true, no: "projectName" },
                      model: {
                        value: _vm.job.projectName,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "projectName", $$v)
                        },
                        expression: "job.projectName"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.projectBatch.slaveVisible && _vm.openProjectConfig
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "projectBatch" }, slot: "projectBatch" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.projectBatch.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.projectBatch.label
                      },
                      slot: "label"
                    }),
                    _c("el-input", {
                      attrs: { no: "projectBatch", disabled: _vm.readonly },
                      model: {
                        value: _vm.job.projectBatch,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "projectBatch", $$v)
                        },
                        expression: "job.projectBatch"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.operateType.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "operateType" }, slot: "operateType" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.operateType.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.operateType.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-advance-select", {
                      attrs: {
                        disabled: _vm.readonly || !_vm.isLclMasterFlag,
                        no: "operateType",
                        filterable: "",
                        "select-type":
                          _vm.selectTypeNames
                            .local_cache_ImportConstants$_cargoTypeAirInputList,
                        "callback-method-type": "value",
                        "default-value": _vm.job.operateType,
                        "callback-params": { key: "operateType" },
                        clearable: false
                      },
                      on: { parentCallBack: _vm.operateType_changeHandler }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.freightTerm.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "freightTerm" }, slot: "freightTerm" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.freightTerm.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.freightTerm.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-advance-select", {
                      attrs: {
                        no: "freightTerm",
                        filterable: "",
                        disabled: _vm.readonly,
                        "select-type":
                          _vm.selectTypeNames.basic_data_ShippingTerm,
                        "callback-method-type": "value",
                        "default-value": _vm.job.freightTerm,
                        "callback-params": { key: "freightTerm" },
                        clearable: false
                      },
                      on: { parentCallBack: _vm.setJobSelectValue }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.cargoType.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "cargoType" }, slot: "cargoType" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.cargoType.isRequire ? "blue" : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.cargoType.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-advance-select", {
                      attrs: {
                        no: "cargoType",
                        filterable: "",
                        disabled: _vm.readonly,
                        "select-type": _vm.selectTypeNames.basic_data_CargoType,
                        "method-params": { air: true },
                        "callback-method-type": "value",
                        "default-value": _vm.job.cargoType,
                        "callback-params": { key: "cargoType" },
                        clearable: false
                      },
                      on: { parentCallBack: _vm.onCargoTypeChagne }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.paymentTermHBL.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "paymentTermHBL" }, slot: "paymentTermHBL" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.paymentTermHBL.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.paymentTermHBL.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-advance-select", {
                      attrs: {
                        no: "paymentTermHBL",
                        filterable: "",
                        disabled: _vm.readonly,
                        "select-type":
                          _vm.selectTypeNames.basic_data_PaymentTerm,
                        "callback-method-type": "value",
                        "default-value": _vm.job.paymentTermHBL,
                        "callback-params": { key: "paymentTermHBL" },
                        clearable: false,
                        placeholder: " "
                      },
                      on: { parentCallBack: _vm.setJobSelectValue }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.paymentTermMBL.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "paymentTermMBL" }, slot: "paymentTermMBL" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.paymentTermMBL.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.paymentTermMBL.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-advance-select", {
                      attrs: {
                        disabled: _vm.readonly || !_vm.isLclMasterFlag,
                        no: "paymentTermMBL",
                        filterable: "",
                        "select-type":
                          _vm.selectTypeNames.basic_data_PaymentTerm,
                        "callback-method-type": "value",
                        "default-value": _vm.job.paymentTermMBL,
                        "callback-params": { key: "paymentTermMBL" },
                        clearable: false,
                        placeholder: " "
                      },
                      on: { parentCallBack: _vm.setJobSelectValue }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.incoTerm.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "incoTerm" }, slot: "incoTerm" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.incoTerm.isRequire ? "blue" : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.incoTerm.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-advance-select", {
                      attrs: {
                        no: "incoTerm",
                        filterable: "",
                        disabled: _vm.readonly,
                        "select-type": _vm.selectTypeNames.basic_data_IncoTerm,
                        "callback-method-type": "value",
                        "default-value": _vm.job.incoTerm,
                        "callback-params": { key: "incoTerm" },
                        clearable: false,
                        placeholder: " "
                      },
                      on: { parentCallBack: _vm.setJobSelectValue }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.transDate.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "transDate" }, slot: "transDate" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.transDate.isRequire ? "blue" : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.transDate.label
                      },
                      slot: "label"
                    }),
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        disabled: _vm.readonly,
                        no: "transDate",
                        type: "date",
                        "value-format": "yyyy-MM-dd",
                        clearable: ""
                      },
                      model: {
                        value: _vm.job.transDate,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "transDate", $$v)
                        },
                        expression: "job.transDate"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.deliverDate.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "deliverDate" }, slot: "deliverDate" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.deliverDate.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.deliverDate.label
                      },
                      slot: "label"
                    }),
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        disabled: _vm.readonly,
                        no: "deliverDate",
                        type: "date",
                        "value-format": "yyyy-MM-dd",
                        clearable: ""
                      },
                      model: {
                        value: _vm.job.deliverDate,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "deliverDate", $$v)
                        },
                        expression: "job.deliverDate"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.arriveStorageDate.slaveVisible
              ? _c(
                  "el-form-item",
                  {
                    attrs: { slot: "arriveStorageDate" },
                    slot: "arriveStorageDate"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.arriveStorageDate.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.arriveStorageDate.label
                      },
                      slot: "label"
                    }),
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        disabled: _vm.readonly,
                        no: "arriveStorageDate",
                        type: "date",
                        "value-format": "yyyy-MM-dd",
                        clearable: ""
                      },
                      model: {
                        value: _vm.job.arriveStorageDate,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "arriveStorageDate", $$v)
                        },
                        expression: "job.arriveStorageDate"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.groundAgentId.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "groundAgentId" }, slot: "groundAgentId" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.groundAgentId.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.groundAgentId.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-advance-select", {
                      attrs: {
                        no: "groundAgentId",
                        filterable: "",
                        disabled: _vm.readonly,
                        "select-type": _vm.selectTypeNames.basic_data_Company,
                        "method-params": { bookingAgent: true, active: true },
                        "callback-params": { key: "groundAgentId" },
                        "callback-method-type": "value",
                        "default-value": _vm.job.groundAgentId || "",
                        placeholder: " "
                      },
                      on: { parentCallBack: _vm.setJobSelectNum }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.txtSalesOffice.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "txtSalesOffice" }, slot: "txtSalesOffice" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.txtSalesOffice.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.txtSalesOffice.label
                      },
                      slot: "label"
                    }),
                    _c("el-input", {
                      attrs: {
                        disabled: true,
                        no: "txtSalesOffice",
                        placeholder: _vm.$t("SeaExport.RequiredItem")
                      },
                      model: {
                        value: _vm.txtSalesOffice,
                        callback: function($$v) {
                          _vm.txtSalesOffice = $$v
                        },
                        expression: "txtSalesOffice"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.sales.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "sales" }, slot: "sales" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.sales.isRequire ? "blue" : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.sales.label
                      },
                      slot: "label"
                    }),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-between"
                        }
                      },
                      [
                        _c("cargo-user-select", {
                          ref: "sales",
                          staticStyle: { flex: "1" },
                          attrs: {
                            disabled:
                              _vm.readonly || _vm.isWithinCloseAccountDate,
                            no: "sales",
                            "method-params": {
                              officeId: _vm.salesOfficeCheck
                                ? _vm.$store.getters.currentOfficeId
                                : "",
                              category: "role",
                              shape: "sales"
                            },
                            "default-value": _vm.job.sales || "",
                            "static-options": _vm.salesList,
                            placeholder: " "
                          },
                          on: { change: _vm.salesChangeHandler }
                        }),
                        _c(
                          "el-checkbox",
                          {
                            staticStyle: {
                              "margin-left": "5px",
                              "margin-right": "0px"
                            },
                            attrs: { disabled: true, no: "provisioned" },
                            model: {
                              value: _vm.job.provisioned,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "provisioned", $$v)
                              },
                              expression: "job.provisioned"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.Accrued")))]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.cargoSalesId.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "cargoSalesId" }, slot: "cargoSalesId" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.cargoSalesId.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.cargoSalesId.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-user-select", {
                      attrs: {
                        no: "cargoSalesId",
                        disabled: _vm.readonly,
                        "method-params": {
                          category: "role",
                          shape: "salesOfGoods"
                        },
                        "default-value": _vm.job.cargoSalesId || "",
                        placeholder: " ",
                        "static-options": _vm.cargoSalesList
                      },
                      on: { change: _vm.cargoSalesChargeHandler }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.salesDepartment.slaveVisible
              ? _c(
                  "el-form-item",
                  {
                    attrs: { slot: "salesDepartment" },
                    slot: "salesDepartment"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.salesDepartment.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.salesDepartment.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-department-new-select", {
                      attrs: {
                        disabled: _vm.readonly || !_vm.job.sales,
                        no: "salesOffice",
                        "sales-id": Number(_vm.job.sales),
                        enables: true,
                        "office-id": _vm.job.salesOffice,
                        "department-id": Number(_vm.job.salesDepartment),
                        placeholder: " "
                      },
                      on: { change: _vm.departmentChangeHandler }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.opOffice.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "opOffice" }, slot: "opOffice" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.opOffice.isRequire ? "blue" : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.opOffice.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-advance-select", {
                      attrs: {
                        no: "opOffice",
                        disabled: _vm.readonly || _vm.opOfficeDisabled,
                        "select-type": _vm.selectTypeNames.basic_data_Office,
                        filterable: "",
                        "callback-params": { key: "opOffice" },
                        "static-options": _vm.cacheOffices,
                        "callback-method-type": "value",
                        "default-value": _vm.job.opOffice || "",
                        placeholder: " "
                      },
                      on: {
                        parentCallBack: function(p) {
                          _vm.setJobSelectNum(p)
                          _vm.job.opDepartment = 0
                          _vm.opOfficeChargeHandler()
                          _vm.contractRuleFieldChange(
                            _vm.job.customerId,
                            _vm.job.designationAgent
                          )
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.opDepartment.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "opDepartment" }, slot: "opDepartment" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.opDepartment.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.opDepartment.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-department-select", {
                      attrs: {
                        disabled: _vm.readonly || _vm.isWithinCloseAccountDate,
                        no: "opDepartment",
                        "office-id": Number(_vm.job.opOffice),
                        enables: true,
                        "department-id": Number(_vm.job.opDepartment),
                        placeholder: " "
                      },
                      on: {
                        change: function(p) {
                          _vm.job.opDepartment = p.value
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.csrOffice.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "csrOffice" }, slot: "csrOffice" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.csrOffice.isRequire ? "blue" : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.csrOffice.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-office-select", {
                      attrs: {
                        no: "csrOffice",
                        disabled: true,
                        "office-id": Number(_vm.job.csrOffice)
                      },
                      on: {
                        change: function(p) {
                          _vm.job.csrOffice = p.value
                          _vm.job.csrDepartment = 0
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.csrDepartment.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "csrDepartment" }, slot: "csrDepartment" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.csrDepartment.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.csrDepartment.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-department-select", {
                      attrs: {
                        no: "csrDepartment",
                        disabled: _vm.readonly,
                        "office-id": Number(_vm.job.csrOffice),
                        enables: true,
                        "department-id": Number(_vm.job.csrDepartment)
                      },
                      on: {
                        change: function(p) {
                          _vm.job.csrDepartment = p.value
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.csr.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "csr" }, slot: "csr" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.csr.isRequire ? "blue" : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.csr.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-user-select", {
                      attrs: {
                        no: "csr",
                        disabled: _vm.readonly,
                        "method-params": { category: "role", shape: "csr" },
                        "default-value": _vm.job.csr || "",
                        placeholder: " ",
                        "static-options": _vm.userPortRoleData.csr
                      },
                      on: { change: _vm.csrChangeHandler }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.op.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "op" }, slot: "op" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.op.isRequire ? "blue" : "",
                      attrs: { slot: "label", label: _vm.elementDict.op.label },
                      slot: "label"
                    }),
                    _c("cargo-user-select", {
                      attrs: {
                        no: "op",
                        disabled: _vm.readonly,
                        "method-params": {
                          category: "role",
                          shape: "op",
                          officeId:
                            _vm.$store.getters.currentOffice.code === "HB"
                              ? ""
                              : _vm.$store.getters.currentOfficeId
                        },
                        "default-value": _vm.job.op || "",
                        placeholder: " ",
                        "static-options": _vm.userPortRoleData.op
                      },
                      on: { change: _vm.opChangeHandler }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.dcOffice.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "dcOffice" }, slot: "dcOffice" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.dcOffice.isRequire ? "blue" : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.dcOffice.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-office-select", {
                      attrs: {
                        no: "dcOffice",
                        disabled: true,
                        "office-id": Number(_vm.job.dcOffice)
                      },
                      on: {
                        change: function(p) {
                          _vm.job.dcOffice = p.value
                          _vm.job.dcDepartment = 0
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.dcDepartment.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "dcDepartment" }, slot: "dcDepartment" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.dcDepartment.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.dcDepartment.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-department-select", {
                      attrs: {
                        no: "dcDepartment",
                        disabled: _vm.readonly,
                        "office-id": Number(_vm.job.dcOffice),
                        enables: true,
                        "department-id": Number(_vm.job.dcDepartment)
                      },
                      on: {
                        change: function(p) {
                          _vm.job.dcDepartment = p.value
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.dc.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "dc" }, slot: "dc" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.dc.isRequire ? "blue" : "",
                      attrs: { slot: "label", label: _vm.elementDict.dc.label },
                      slot: "label"
                    }),
                    _c("cargo-user-select", {
                      attrs: {
                        no: "dc",
                        disabled: _vm.readonly,
                        "method-params": { category: "role", shape: "doc" },
                        "default-value": _vm.job.dc || "",
                        placeholder: " ",
                        "static-options": _vm.userPortRoleData.doc
                      },
                      on: { change: _vm.dcChangeHandler }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.plannerOffice &&
            _vm.elementDict.plannerOffice.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "plannerOffice" }, slot: "plannerOffice" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.plannerOffice.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.plannerOffice.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-office-select", {
                      attrs: {
                        no: "plannerOffice",
                        disabled: true,
                        "office-id": Number(_vm.job.plannerOffice)
                      },
                      on: {
                        change: function(p) {
                          _vm.job.plannerOffice = p.value
                          _vm.job.plannerDepartment = 0
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.plannerDepartment &&
            _vm.elementDict.plannerDepartment.slaveVisible
              ? _c(
                  "el-form-item",
                  {
                    attrs: { slot: "plannerDepartment" },
                    slot: "plannerDepartment"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.plannerDepartment.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.plannerDepartment.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-department-select", {
                      attrs: {
                        no: "plannerDepartment",
                        disabled: _vm.readonly,
                        "office-id": Number(_vm.job.plannerOffice),
                        enables: true,
                        "department-id": Number(_vm.job.plannerDepartment)
                      },
                      on: {
                        change: function(p) {
                          _vm.job.plannerDepartment = p.value
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.planner.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "planner" }, slot: "planner" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.planner.isRequire ? "blue" : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.planner.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-user-select", {
                      attrs: {
                        no: "planner",
                        disabled: _vm.readonly,
                        "method-params": { category: "role", shape: "airline" },
                        "default-value": _vm.job.planner || "",
                        placeholder: " ",
                        "static-options": _vm.userPortRoleData.airline
                      },
                      on: { change: _vm.plannerChangeHandler }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.loadingPortOp.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "loadingPortOp" }, slot: "loadingPortOp" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.loadingPortOp.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.loadingPortOp.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-user-select", {
                      attrs: {
                        no: "loadingPortOp",
                        disabled: _vm.readonly,
                        "method-params": { category: "role", shape: "aiop" },
                        "default-value": _vm.job.loadingPortOp || "",
                        placeholder: " "
                      },
                      on: {
                        change: function(p) {
                          _vm.job.loadingPortOp = p.value || 0
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.destinationPortOp.slaveVisible
              ? _c(
                  "el-form-item",
                  {
                    attrs: { slot: "destinationPortOp" },
                    slot: "destinationPortOp"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.destinationPortOp.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.destinationPortOp.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-user-select", {
                      attrs: {
                        no: "destinationPortOp",
                        disabled: _vm.readonly,
                        "method-params": { category: "role", shape: "aiop" },
                        "default-value": _vm.job.destinationPortOp || "",
                        placeholder: " "
                      },
                      on: {
                        change: function(p) {
                          _vm.job.destinationPortOp = p.value || 0
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.siteOP.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "siteOP" }, slot: "siteOP" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.siteOP.isRequire ? "blue" : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.siteOP.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-user-select", {
                      attrs: {
                        disabled: _vm.readonly,
                        "method-params": {
                          officeId: _vm.$store.getters.currentOfficeId,
                          category: "role",
                          shape: "siteOp"
                        },
                        "default-value": _vm.job.siteOP || "",
                        placeholder: " ",
                        "static-options": _vm.userPortRoleData.siteOp
                      },
                      on: {
                        change: function(p) {
                          _vm.JobUtils.siteOpChangeHandler(_vm.job, p)
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.overseaOp.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "overseaOp" }, slot: "overseaOp" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.overseaOp.isRequire ? "blue" : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.overseaOp.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-user-select", {
                      ref: "overseaOp",
                      staticClass: "input2",
                      attrs: {
                        no: "overseaOp",
                        disabled: _vm.readonly,
                        "default-value": _vm.job.overseaOp || "",
                        "method-params": {
                          category: "role",
                          shape: "overseaOp"
                        },
                        "static-options": _vm.isHC
                          ? null
                          : _vm.userPortRoleData.overseaOp ||
                            _vm.overseaAgentUsersList,
                        "merge-load": true
                      },
                      on: {
                        change: function(p) {
                          _vm.job.overseaOp = p.value
                          _vm.OverseaCustomerUtils.overseaOpChangeHandler(
                            _vm.view,
                            p
                          )
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "el-form-item",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.elementDict.userDefinedRoleId1.slaveVisible &&
                      _vm.isAddUserDefinedRoles,
                    expression:
                      "elementDict.userDefinedRoleId1.slaveVisible && isAddUserDefinedRoles"
                  }
                ],
                attrs: { slot: "userDefinedRoleId1" },
                slot: "userDefinedRoleId1"
              },
              [
                _c("line-label", {
                  class: _vm.elementDict.userDefinedRoleId1.isRequire
                    ? "blue"
                    : "",
                  attrs: {
                    slot: "label",
                    label: _vm.elementDict.userDefinedRoleId1.label
                  },
                  slot: "label"
                }),
                _c("cargo-user-select", {
                  ref: "userDefinedRoleId1",
                  attrs: {
                    no: "userDefinedRoleId1",
                    disabled: _vm.readonly,
                    "method-params": {
                      officeId: _vm.$store.getters.currentOfficeId,
                      category: "role",
                      shape: "userDefinedRole1"
                    },
                    "default-value": _vm.job.userDefinedRoleId1 || "",
                    "merge-load": true,
                    placeholder: " "
                  },
                  on: {
                    change: function(p) {
                      _vm.userDefinedRoleId1Handler(p)
                    }
                  }
                })
              ],
              1
            ),
            _vm.elementDict.userDefinedRoleId2.slaveVisible &&
            _vm.isAddUserDefinedRoles
              ? _c(
                  "el-form-item",
                  {
                    attrs: { slot: "userDefinedRoleId2" },
                    slot: "userDefinedRoleId2"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.userDefinedRoleId2.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.userDefinedRoleId2.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-user-select", {
                      ref: "userDefinedRoleId2",
                      attrs: {
                        no: "userDefinedRoleId2",
                        disabled: _vm.readonly,
                        "method-params": {
                          officeId: _vm.$store.getters.currentOfficeId,
                          category: "role",
                          shape: "userDefinedRole2"
                        },
                        "default-value": _vm.job.userDefinedRoleId2 || "",
                        "merge-load": true,
                        placeholder: " "
                      },
                      on: {
                        change: function(p) {
                          _vm.userDefinedRoleId2Handler(p)
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.userDefinedRoleId3 &&
            _vm.elementDict.userDefinedRoleId3.slaveVisible &&
            _vm.isAddUserDefinedRoles
              ? _c(
                  "el-form-item",
                  {
                    attrs: { slot: "userDefinedRoleId3" },
                    slot: "userDefinedRoleId3"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.userDefinedRoleId3.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.userDefinedRoleId3.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-user-select", {
                      ref: "userDefinedRoleId3",
                      attrs: {
                        no: "userDefinedRoleId3",
                        disabled: _vm.readonly,
                        "method-params": {
                          officeId: _vm.$store.getters.currentOfficeId,
                          category: "role",
                          shape: "userDefinedRole3"
                        },
                        "default-value": _vm.job.userDefinedRoleId3 || "",
                        "merge-load": true,
                        "static-options": _vm.userPortRoleData.userDefinedRole3
                      },
                      on: {
                        change: function(p) {
                          _vm.userDefinedRoleId3Handler(p)
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.userDefinedRoleId4 &&
            _vm.elementDict.userDefinedRoleId4.slaveVisible &&
            _vm.isAddUserDefinedRoles
              ? _c(
                  "el-form-item",
                  {
                    attrs: { slot: "userDefinedRoleId4" },
                    slot: "userDefinedRoleId4"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.userDefinedRoleId4.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.userDefinedRoleId4.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-user-select", {
                      ref: "userDefinedRoleId4",
                      attrs: {
                        no: "userDefinedRoleId4",
                        disabled: _vm.readonly,
                        "method-params": {
                          officeId: _vm.$store.getters.currentOfficeId,
                          category: "role",
                          shape: "userDefinedRole4"
                        },
                        "default-value": _vm.job.userDefinedRoleId4 || "",
                        "merge-load": true,
                        "static-options": _vm.userPortRoleData.userDefinedRole4
                      },
                      on: {
                        change: function(p) {
                          _vm.userDefinedRoleId4Handler(p)
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.userDefinedRoleId5 &&
            _vm.elementDict.userDefinedRoleId5.slaveVisible &&
            _vm.isAddUserDefinedRoles
              ? _c(
                  "el-form-item",
                  {
                    attrs: { slot: "userDefinedRoleId5" },
                    slot: "userDefinedRoleId5"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.userDefinedRoleId5.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.userDefinedRoleId5.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-user-select", {
                      ref: "userDefinedRoleId5",
                      attrs: {
                        no: "userDefinedRoleId5",
                        disabled: _vm.readonly,
                        "method-params": {
                          officeId: _vm.$store.getters.currentOfficeId,
                          category: "role",
                          shape: "userDefinedRole5"
                        },
                        "default-value": _vm.job.userDefinedRoleId5 || "",
                        "merge-load": true
                      },
                      on: {
                        change: function(p) {
                          _vm.userDefinedRoleId5Handler(p)
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.userDefinedRoleId6 &&
            _vm.elementDict.userDefinedRoleId6.slaveVisible &&
            _vm.isAddUserDefinedRoles
              ? _c(
                  "el-form-item",
                  {
                    attrs: { slot: "userDefinedRoleId6" },
                    slot: "userDefinedRoleId6"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.userDefinedRoleId6.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.userDefinedRoleId6.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-user-select", {
                      ref: "userDefinedRoleId6",
                      attrs: {
                        no: "userDefinedRoleId6",
                        disabled: _vm.readonly,
                        "method-params": {
                          officeId: _vm.$store.getters.currentOfficeId,
                          category: "role",
                          shape: "userDefinedRole6"
                        },
                        "default-value": _vm.job.userDefinedRoleId6 || "",
                        "merge-load": true
                      },
                      on: {
                        change: function(p) {
                          _vm.userDefinedRoleId6Handler(p)
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.userDefinedRoleId7 &&
            _vm.elementDict.userDefinedRoleId7.slaveVisible &&
            _vm.isAddUserDefinedRoles
              ? _c(
                  "el-form-item",
                  {
                    attrs: { slot: "userDefinedRoleId7" },
                    slot: "userDefinedRoleId7"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.userDefinedRoleId7.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.userDefinedRoleId7.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-user-select", {
                      ref: "userDefinedRoleId7",
                      attrs: {
                        no: "userDefinedRoleId7",
                        disabled: _vm.readonly,
                        "method-params": {
                          officeId: _vm.$store.getters.currentOfficeId,
                          category: "role",
                          shape: "userDefinedRole7"
                        },
                        "default-value": _vm.job.userDefinedRoleId7 || "",
                        "merge-load": true
                      },
                      on: {
                        change: function(p) {
                          _vm.userDefinedRoleId7Handler(p)
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.userDefinedRoleId8 &&
            _vm.elementDict.userDefinedRoleId8.viewable &&
            _vm.isAddUserDefinedRoles
              ? _c(
                  "el-form-item",
                  {
                    attrs: { slot: "userDefinedRoleId8" },
                    slot: "userDefinedRoleId8"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.userDefinedRoleId8.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.userDefinedRoleId8.label
                      },
                      slot: "label"
                    }),
                    _c("cargo-user-select", {
                      ref: "userDefinedRoleId8",
                      attrs: {
                        no: "userDefinedRoleId8",
                        "method-params": {
                          officeId: _vm.$store.getters.currentOfficeId,
                          category: "role",
                          shape: "userDefinedRole8"
                        },
                        "default-multiple-value": _vm.toNumArray(
                          _vm.job.userDefinedRoleId8
                        ),
                        disabled: _vm.readonly,
                        multiple: true,
                        "merge-load": true,
                        placeholder: _vm.readonly ? " " : ""
                      },
                      on: {
                        change: function(p) {
                          _vm.job.userDefinedRoleId8 = _vm.toTxt(p.value)
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.satisfiedRequests.slaveVisible
              ? _c(
                  "div",
                  {
                    attrs: { slot: "satisfiedRequests" },
                    slot: "satisfiedRequests"
                  },
                  [
                    _c("special-requests-grid", {
                      attrs: {
                        disabled: _vm.readonly,
                        no: "satisfiedRequests",
                        "is-edit": _vm.isEdit,
                        "customer-id": Number(_vm.job.customerId),
                        lob: _vm.job.lob,
                        job: _vm.job
                      },
                      model: {
                        value: _vm.job.satisfiedRequests,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "satisfiedRequests", $$v)
                        },
                        expression: "job.satisfiedRequests"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.userDefinedField1.slaveVisible
              ? _c(
                  "el-form-item",
                  {
                    attrs: { slot: "userDefinedField1" },
                    slot: "userDefinedField1"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.userDefinedField1.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.userDefinedField1.label
                      },
                      slot: "label"
                    }),
                    _c("el-input", {
                      attrs: {
                        disabled: _vm.readonly,
                        no: "userDefinedField1",
                        type: "textarea",
                        rows: 5
                      },
                      nativeOn: {
                        dblclick: function($event) {
                          return _vm.showAdvanceTextDialog(
                            _vm.elementDict.userDefinedField1.label,
                            _vm.job.userDefinedField1,
                            0,
                            function(val) {
                              _vm.job.userDefinedField1 = val
                            }
                          )
                        }
                      },
                      model: {
                        value: _vm.job.userDefinedField1,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "userDefinedField1", $$v)
                        },
                        expression: "job.userDefinedField1"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.userDefinedField2.slaveVisible
              ? _c(
                  "el-form-item",
                  {
                    attrs: { slot: "userDefinedField2" },
                    slot: "userDefinedField2"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.userDefinedField2.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.userDefinedField2.label
                      },
                      slot: "label"
                    }),
                    _c("el-input", {
                      attrs: {
                        disabled: _vm.readonly,
                        no: "userDefinedField2",
                        type: "textarea",
                        rows: 5
                      },
                      nativeOn: {
                        dblclick: function($event) {
                          return _vm.showAdvanceTextDialog(
                            _vm.elementDict.userDefinedField2.label,
                            _vm.job.userDefinedField2,
                            0,
                            function(val) {
                              _vm.job.userDefinedField2 = val
                            }
                          )
                        }
                      },
                      model: {
                        value: _vm.job.userDefinedField2,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "userDefinedField2", $$v)
                        },
                        expression: "job.userDefinedField2"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.userDefinedField3.slaveVisible
              ? _c(
                  "el-form-item",
                  {
                    attrs: { slot: "userDefinedField3" },
                    slot: "userDefinedField3"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.userDefinedField3.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.userDefinedField3.label
                      },
                      slot: "label"
                    }),
                    _c("el-input", {
                      attrs: {
                        disabled: _vm.readonly,
                        no: "userDefinedField3",
                        type: "textarea",
                        rows: 5
                      },
                      nativeOn: {
                        dblclick: function($event) {
                          return _vm.showAdvanceTextDialog(
                            _vm.elementDict.userDefinedField3.label,
                            _vm.job.userDefinedField3,
                            0,
                            function(val) {
                              _vm.job.userDefinedField3 = val
                            }
                          )
                        }
                      },
                      model: {
                        value: _vm.job.userDefinedField3,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "userDefinedField3", $$v)
                        },
                        expression: "job.userDefinedField3"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.userDefinedField4.slaveVisible
              ? _c(
                  "el-form-item",
                  {
                    attrs: { slot: "userDefinedField4" },
                    slot: "userDefinedField4"
                  },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.userDefinedField4.isRequire
                        ? "blue"
                        : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.userDefinedField4.label
                      },
                      slot: "label"
                    }),
                    _c("el-input", {
                      attrs: {
                        disabled: _vm.readonly,
                        no: "userDefinedField4",
                        type: "textarea",
                        rows: 5
                      },
                      nativeOn: {
                        dblclick: function($event) {
                          return _vm.showAdvanceTextDialog(
                            _vm.elementDict.userDefinedField4.label,
                            _vm.job.userDefinedField4,
                            0,
                            function(val) {
                              _vm.job.userDefinedField4 = val
                            }
                          )
                        }
                      },
                      model: {
                        value: _vm.job.userDefinedField4,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "userDefinedField4", $$v)
                        },
                        expression: "job.userDefinedField4"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.taxNature && _vm.elementDict.taxNature.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "taxNature" }, slot: "taxNature" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.taxNature.isRequire ? "blue" : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.taxNature.label
                      },
                      slot: "label"
                    }),
                    _c(
                      "el-select",
                      {
                        attrs: {
                          disabled: _vm.readonly,
                          no: "taxNature",
                          placeholder: _vm.$t("SeaExport.PleaseSelect"),
                          size: "mini"
                        },
                        model: {
                          value: _vm.job.taxNature,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "taxNature", $$v)
                          },
                          expression: "job.taxNature"
                        }
                      },
                      _vm._l(_vm.TAX_NATURES, function(item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: {
                            label: _vm.isZh
                              ? item.chineseName
                              : item.englishName,
                            value: item.code
                          }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm.elementDict.rateType && _vm.elementDict.rateType.slaveVisible
              ? _c(
                  "el-form-item",
                  { attrs: { slot: "rateType" }, slot: "rateType" },
                  [
                    _c("line-label", {
                      class: _vm.elementDict.rateType.isRequire ? "blue" : "",
                      attrs: {
                        slot: "label",
                        label: _vm.elementDict.rateType.label
                      },
                      slot: "label"
                    }),
                    _c(
                      "el-select",
                      {
                        attrs: {
                          disabled: _vm.readonly,
                          no: "rateType",
                          clearable: "",
                          placeholder: _vm.$t("SeaExport.PleaseSelect"),
                          size: "mini"
                        },
                        model: {
                          value: _vm.job.rateType,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "rateType", $$v)
                          },
                          expression: "job.rateType"
                        }
                      },
                      _vm._l(_vm.rateType, function(item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: {
                            label: _vm.isZh
                              ? item.chineseName
                              : item.englishName,
                            value: item.code
                          }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ],
          2
        ),
        _c("sop-dialog", {
          attrs: {
            visible: _vm.sopDialog.visible,
            "cmp-idx": _vm.sopDialog.cmpIdx,
            job: _vm.job,
            agent: _vm.sopDialog.agent,
            lob: "AI",
            "contact-list": _vm.sopDialog.contactList
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.sopDialog, "visible", $event)
            },
            updateJob: function($event) {
              return _vm.$emit("updateJob")
            }
          }
        }),
        _vm.contactInfoDialog.visible
          ? _c("cargo-contacts-info-dialog", {
              attrs: {
                visible: _vm.contactInfoDialog.visible,
                "customer-id": _vm.job.customerId,
                "customer-contact": _vm.job.customerContact
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.contactInfoDialog, "visible", $event)
                }
              }
            })
          : _vm._e(),
        _c("import-prompt-title-dialog", {
          attrs: {
            visible: _vm.importPromptTitleDialog.visible,
            lob: _vm.job.lob
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.importPromptTitleDialog, "visible", $event)
            },
            selected: _vm.onExcerptionChangeFunc
          }
        }),
        _c("import-bill-address-title-dialog", {
          attrs: { visible: _vm.billAddressDialog.visible, job: _vm.job },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.billAddressDialog, "visible", $event)
            },
            callback: _vm.codeSearchCallback
          }
        }),
        _c(
          "el-dialog",
          {
            directives: [
              { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
            ],
            attrs: {
              visible: _vm.advanceTextDialog.visible,
              title: _vm.advanceTextDialog.title,
              width: "665px",
              "close-on-click-modal": false,
              "close-on-press-escape": false
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.advanceTextDialog, "visible", $event)
              }
            }
          },
          [
            _c("cargo-rich-textarea", {
              staticStyle: { height: "320px" },
              attrs: {
                disabled: _vm.readonly,
                "text-chars": _vm.advanceTextDialog.textChars,
                "auto-uppercase": _vm.advanceTextDialog.isUppercase,
                "warning-count": -1
              },
              model: {
                value: _vm.advanceTextDialog.value,
                callback: function($$v) {
                  _vm.$set(_vm.advanceTextDialog, "value", $$v)
                },
                expression: "advanceTextDialog.value"
              }
            }),
            _c(
              "span",
              { attrs: { slot: "footer" }, slot: "footer" },
              [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isEdit,
                        expression: "isEdit"
                      }
                    ],
                    attrs: { no: "confirm", type: "primary" },
                    on: { click: _vm.finishAdvanceText }
                  },
                  [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { no: "close" },
                    on: {
                      click: function($event) {
                        _vm.advanceTextDialog.visible = false
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
                )
              ],
              1
            )
          ],
          1
        ),
        _c("stamp-picture-view", {
          attrs: {
            visible: _vm.stampPictureView.visible,
            "business-documents": _vm.stampPictureView.businessDocuments
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.stampPictureView, "visible", $event)
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }